class ConfigNotFoundException extends Error {}

export default ConfigNotFoundException;
